// material
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export default function TableFetchError({ ...other }) {
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        Erro ao tentar encontrar resultados
      </Typography>
      <Typography variant="body2" align="center">
        Tente novamente ou reinicie a página
      </Typography>
    </Paper>
  );
}
